const UserSignupSources = [
    'Please select an option', 'Linkedin', 'Twitter', 'Webinar',
    'Network / Referral from existing clients',
    'Conference', 'Contacted by Aura', 'Other' ]

export default UserSignupSources
